import React, { memo } from 'react';
import { Progress } from 'antd';
import styled, { useTheme } from 'styled-components';

const StyledProgress = styled(Progress)<{ $height: number }>`
  &.ant-progress {
    height: ${({ $height }) => $height}px;
    font-size: ${({ $height }) => $height}px;
    line-height: ${({ $height }) => $height}px;
  }

  .ant-progress-outer {
    height: ${({ $height }) => $height}px;
    font-size: ${({ $height }) => $height}px;
  }

  .ant-progress-inner {
    height: ${({ $height }) => $height}px;

    .ant-progress-bg {
      height: ${({ $height }) => $height}px !important;
      background-color: ${({ theme }) => theme.colors.gogo};
    }
  }
`;

export const ProgressBar = memo<{ percentage: number; height?: number }>(
  ({ percentage, height }) => {
    const theme = useTheme();

    return (
      <StyledProgress
        percent={percentage}
        showInfo={false}
        $height={height ?? 6}
        trailColor={theme.colors.porcelain2}
      />
    );
  },
);
